import { v4 as uuid } from "uuid";
import * as UserConst from "actions/userConst";
import { useSelector, useDispatch } from 'react-redux'

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk, current } from '@reduxjs/toolkit'
import TimeRegistrationAPI from "@/api/TimeRegistrationAPI";

import { show } from '@/reducers/Modal'
import * as CONST from "@/actions/globalConst";
import  {UserModel} from "@/models/User";
import {AddressModel} from "@/models/Address";
import {TIME_REGISTRATION} from "@/actions/globalConst";
import { TenantModel, TenantCompanyModel } from "@/models/Tenant";
import { TimeRegistrationModel } from "@/models/TimeRegistration.ts";
import {add} from "@/reducers/NotificationReducer";

export const initialState = {
  status: false,
  customers: false,
  filters: [],
  currentfilters: [],
  tenants: false,
  sectors: false,
  worktype: [],
  users: false,
  key: "",
  showTimeRegistration: false,
  selected: new TimeRegistrationModel(),
  items: []
};

export const exportRegistration = createAsyncThunk(
  TIME_REGISTRATION.EXPORT,
  async (data, event) => {
    let response = null;
    try {
        const cf = event.getState().TimeRegistrationReducer.currentfilters;
          response = await TimeRegistrationAPI.exportTimeRegistration( (cf) ).then((response) => {
            if(response.data.data.notification) {
                //store.dispatch(add( response.data.data.notification ))
            }
            return response;
          });

          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response;
  }
)


export const initTimeRegistration = createAsyncThunk(
  TIME_REGISTRATION.INIT,
  async (data, event) => {
    let response = null;
    try {
          response = await TimeRegistrationAPI.startTimeRegistration( );
                const authReducer = event.getState().AuthReducer;
                let timeRegistrationModel = new TimeRegistrationModel();
                timeRegistrationModel.user = event.getState().AuthReducer.user.user;
                response.data.model = timeRegistrationModel;
          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response;
  }
)

export const LOAD_TIME_REGISTRATIONS = createAsyncThunk(
  TIME_REGISTRATION.LOAD_TIME_REGISTRATIONS,
  async (data, event) => {
    let response = null;
    try {
          response = await TimeRegistrationAPI.getAll(data);
          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response;
  }
)

export const SAVE_TIME_REGISTRATIONS = createAsyncThunk(
  TIME_REGISTRATION.SAVE_TIME_REGISTRATION,
  async (data, event) => {
    let response = null;
    try {
          response = await TimeRegistrationAPI.saveTimeRegistration(data)
          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response;
  }
)

export const DELETE_TIME_REGISTRATION = createAsyncThunk(
  TIME_REGISTRATION.DELETE_TIME_REGISTRATION,
  async (data, event) => {
    let response = null;
    try {
          response = await TimeRegistrationAPI.deleteTimeRegistration(data)
          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response;
  }
)



const TimeRegistrationReducer = createSlice({
  name: 'time_registration',
  initialState,
  reducers: {
      showTimeRegistration(state, item = null) {
          if(item) {
              state.selected = new TimeRegistrationModel(item.payload);
          }
          state.showTimeRegistration = true;
          state.key = uuid().slice(0, 8);
          },
          hideRegistration(state, action) {
              state.selected = new TimeRegistrationModel();
              state.showTimeRegistration = false;
              state.key = uuid().slice(0, 8);
          }
    // omit existing reducers here
  },
  extraReducers(builder) {
      TIME_REGISTRATION.EXPORT
      builder.addCase(exportRegistration.fulfilled, (state, action) => {
          });
      builder.addCase(DELETE_TIME_REGISTRATION.fulfilled, (state, action) => {
          state.items = action.payload.data.data;
          });
          
     builder.addCase(LOAD_TIME_REGISTRATIONS.fulfilled, (state, action) => {
         state.items = action.payload.data.data;
         state.filters = action.payload.data.filterData;
         
         if(action.payload.data.currentfilter) {
            state.currentfilters = action.payload.data.currentfilter;
         }
         
         if(action.payload.data.fieldData) {
            state.customers = action.payload.data.fieldData.customers;
            state.tenants = action.payload.data.fieldData.tenants;
            state.sectors = action.payload.data.fieldData.sectors;
            state.users = action.payload.data.fieldData.users;
            state.worktype = action.payload.data.fieldData.worktype;
             
         }
//        state.key = uuid().slice(0, 8);
      
    }).addCase(LOAD_TIME_REGISTRATIONS.rejected, (state, action) => {
//        state.status = UserConst.USER_STATE_ERROR
//        state.error = action.payload;
      })

     builder.addCase(SAVE_TIME_REGISTRATIONS.fulfilled, (state, action) => {
      state.items = action.payload.data.data;
      state.selected = new TimeRegistrationModel();
    }).addCase(SAVE_TIME_REGISTRATIONS.rejected, (state, action) => {
      })
      
     builder.addCase(initTimeRegistration.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
            state.customers = action.payload.data.customers;
            state.tenants = action.payload.data.tenants;
            state.sectors = action.payload.data.sectors;
            state.users = action.payload.data.users;
            state.worktype = action.payload.data.worktype;
            state.showTimeRegistration = true;
            state.selected = new TimeRegistrationModel(action.payload.model);
//        state.status = UserConst.USER_STATE_IDLE
//        state.error = null;
//        state.selected = null;
        state.key = uuid().slice(0, 8);
      
    }).addCase(initTimeRegistration.rejected, (state, action) => {
//        state.status = UserConst.USER_STATE_ERROR
//        state.error = action.payload;
      })
      
      
  }
})
export const { showTimeRegistration, hideRegistration } = TimeRegistrationReducer.actions;
export default TimeRegistrationReducer.reducer